import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import { RemoveCircle } from "@mui/icons-material";
import { Link } from "react-router-dom";
import useResponsive from "../../../hooks/useResponsive";
import { MembersFieldDto } from "../../../types/membersTypes";

interface EventParticipantsProps {
  participants: MembersFieldDto[];
  removeParticipant: (participant: MembersFieldDto) => void;
  hasPermission: boolean | undefined;
}

/**
 * Displays the participants of an event
 * displays a remove button if the user is logged in and has permissions
 * @param participants - the participants of the event
 * @param removeParticipant - function to remove a participant from the event
 * @param hasPermission - boolean indicating if the user has permissions to remove participants
 * @returns - the participants component
 */
const EventParticipants: React.FunctionComponent<EventParticipantsProps> = ({
  participants,
  removeParticipant,
  hasPermission,
}: EventParticipantsProps) => {
  const isMobile = useResponsive("down", "md");

  // function to handle the remove participant button
  const handleRemoveParticipant = (participant: MembersFieldDto) => {
    removeParticipant(participant);
  };

  return (
    <Grid container columns={{ xs: 2, sm: 5, xl: 6 }}>
      {participants.map((item, index) => (
        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            direction: "row",
            alignItems: "center",
            position: "relative",
            "&:hover button": { opacity: 1 },
          }}
          key={index}
        >
          <Link to={`/gesamtuebersicht/${item.memberId}`} style={{ textDecoration: "none", color: "inherit" }}>
            <Typography key={index} variant="subtitle1" fontSize={14}>
              {item.firstname} {item.lastname}
            </Typography>
          </Link>
          {hasPermission && (
            <IconButton
              sx={{
                width: 20,
                height: 20,
                opacity: isMobile ? 1 : 0,
                "&:hover": { opacity: 1 },
              }}
              onClick={() => {
                handleRemoveParticipant(item);
              }}
            >
              <RemoveCircle sx={{ fontSize: 15, "&:hover": { color: "#d32f2f" } }} />
            </IconButton>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default EventParticipants;
